import React, { ReactNode } from "react";
import { Typography } from "./typography";

interface StackSelectionCardProps {
  isSelected: boolean;
  onClick: () => void;
  title: string;
  description: string;
  icon?: string;
  iconBgColor?: string;
  footer?: ReactNode;
  variant?: "default" | "compact";
  disabled?: boolean;
}

const StackSelectionCard: React.FC<StackSelectionCardProps> = ({
  isSelected,
  onClick,
  title,
  description,
  icon,
  iconBgColor = "bg-pink-100",
  footer,
  variant = "default",
  disabled = false,
}) => {
  const cardClasses = `
    ${variant === "compact" ? "flex-1" : ""} 
    p-4 rounded-2xl border-2 transition-all 
    ${
      disabled
        ? "cursor-not-allowed opacity-60 bg-gray-50 border-gray-200"
        : `cursor-pointer ${
            isSelected
              ? "border-accent-pink"
              : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
          }`
    }
  `;

  const radioSize = variant === "compact" ? "w-5 h-5" : "w-6 h-6";
  const radioDotSize = variant === "compact" ? "w-2.5 h-2.5" : "w-3 h-3";

  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  return (
    <div className={cardClasses} onClick={handleClick}>
      <div className="flex items-start justify-between mb-3">
        <div
          className={variant === "compact" ? "flex flex-col gap-3" : "flex-1"}
        >
          {icon && variant === "compact" && (
            <div
              className={`w-10 h-10 ${iconBgColor} rounded-full flex items-center justify-center`}
            >
              <img src={icon} alt={title} />
            </div>
          )}
          <div className="flex-1">
            <Typography
              variant="h3"
              className={variant === "compact" ? "mb-1" : "mb-2"}
            >
              {title}
            </Typography>
            <Typography
              variant="p"
              className={variant === "compact" ? "text-sm text-gray-600" : ""}
            >
              {description}
            </Typography>
            {disabled && (
              <div className="mt-3 inline-block">
                <span className="bg-accent-pink/10 text-accent-pink px-3 py-1.5 rounded-full text-xs font-semibold border border-accent-pink/20">
                  Coming soon!
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="ml-4">
          <div
            className={`${radioSize} rounded-full border-2 flex items-center justify-center ${
              isSelected ? "border-accent-pink" : "border-gray-300"
            }`}
          >
            {isSelected && (
              <div
                className={`${radioDotSize} rounded-full bg-accent-pink`}
              ></div>
            )}
          </div>
        </div>
      </div>

      {footer && <div className="mt-4">{footer}</div>}
    </div>
  );
};

export default StackSelectionCard;
